import React, { useState } from "react";
import { Form, Button, Alert, Spinner } from "react-bootstrap";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const CreateAnnouncements = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [date, setDate] = useState("");
  const [hasImage, setHasImage] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess("");
    setError("");
    try {
      const res = await fetch(`${API_BASE_URL}/announcement`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ title, content, date, hasImage, imageUrl }),
      });
      if (!res.ok) throw new Error("Failed to create announcement");
      setSuccess("Announcement created successfully!");
      setTitle("");
      setContent("");
      setDate("");
      setHasImage(false);
      setImageUrl("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2>Create Announcement</h2>
      {success && <Alert variant="success">{success}</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="title">
          <Form.Label>Title</Form.Label>
          <Form.Control
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="content">
          <Form.Label>Content</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="date">
          <Form.Label>Date</Form.Label>
          <Form.Control
            type="text"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            placeholder="e.g. September 30th, 2024"
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="hasImage">
          <Form.Check
            type="checkbox"
            label="Has Image?"
            checked={hasImage}
            onChange={(e) => setHasImage(e.target.checked)}
          />
        </Form.Group>
        {hasImage && (
          <Form.Group className="mb-3" controlId="imageUrl">
            <Form.Label>Image URL</Form.Label>
            <Form.Control
              type="text"
              value={imageUrl}
              onChange={(e) => setImageUrl(e.target.value)}
              placeholder="Paste image URL here"
            />
          </Form.Group>
        )}
        <Button variant="primary" type="submit" disabled={loading}>
          {loading ? (
            <Spinner size="sm" animation="border" />
          ) : (
            "Create Announcement"
          )}
        </Button>
      </Form>
    </div>
  );
};

export default CreateAnnouncements;
